// src/components/CookieBanner.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookieConsent';

export default function CookieBanner() {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-label={t('cookie.ariaLabel')}
            className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white px-4 py-4 shadow-lg sm:px-6"
        >
            <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <p className="text-sm text-gray-600 leading-relaxed">
                    {t('cookie.body')}{' '}
                    <Link to="/privacy-policy" className="underline text-blue-600 hover:text-blue-800">
                        {t('cookie.privacy')}
                    </Link>
                    {' '}{t('cookie.and')}{' '}
                    <Link to="/terms" className="underline text-blue-600 hover:text-blue-800">
                        {t('cookie.terms')}
                    </Link>
                    .
                </p>
                <button
                    onClick={accept}
                    className="shrink-0 rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                >
                    {t('cookie.gotIt')}
                </button>
            </div>
        </div>
    );
}
